/**
 * @module use-cases/shippingModel/slice
 * @desc shippingModel Slice (Reducers and ExtraReducers)
 *
 */

import { createSlice } from 'core/use-cases/utilities';
import { Utilities } from 'core/domains';

import { actions } from '../actions';
import { initialState } from './initial-state';

const shippingModelSlice = createSlice({
  name: 'shippingModel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actions.currentDeliveryModeFetch.request, (state) => {
      state.status = Utilities.STATUS.RUNNING;
    });

    builder.addCase(actions.currentDeliveryModeFetch.failure, (state, { meta }) => {
      state.status = Utilities.STATUS.ERROR;
      state.updatedAt = meta?.updatedAt;
    });

    builder.addCase(actions.currentDeliveryModeFetch.success, (state, { meta }) => {
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta?.updatedAt;
    });

    builder.addCase(actions.availableDeliveryModesFetch.request, (state) => {
      state.status = Utilities.STATUS.RUNNING;
      state.toggleActive = true;
    });

    builder.addCase(actions.availableDeliveryModesFetch.failure, (state, { meta }) => {
      state.status = Utilities.STATUS.ERROR;
      state.updatedAt = meta?.updatedAt;
    });

    builder.addCase(actions.availableDeliveryModesFetch.success, (state, { payload, meta }) => {
      state.data = payload;
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta?.updatedAt;
    });

    builder.addCase(actions.toggleNewShippingModelActive, (state, { payload = false }) => {
      state.toggleActive = payload;
    });
  },
});

export const { reducer } = shippingModelSlice;
export { actions };
